import React from 'react';
import BrutalistNavbar from '../components/layout/BrutalistNavbar';
import BrutalistFooter from '../components/layout/BrutalistFooter';
import BrutalistTariffs from '../components/tariffs/BrutalistTariffs';
import { Toaster } from '../components/ui/toaster';
import ScrollToTop from '../components/ui/ScrollToTop';

const TariffsPage = () => {
  return (
    <div className="min-h-screen bg-background text-foreground font-sans selection:bg-accent selection:text-white">
      <BrutalistNavbar />
      <main>
        <BrutalistTariffs />
      </main>
      <BrutalistFooter />
      <Toaster />
      <ScrollToTop />
    </div>
  );
};

export default TariffsPage;
